import { APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'
import i18n from '@flatsy/utils/translations'
import { applicantsList } from './GetApplicantsListOrFalse'

export const formatCandidatRef = (applicant: applicantsList, key?: number): string => {
  if (applicant.kind === APPLICANT_KIND.main) {
    return `${i18n.t('applicant')} 1`
  }

  if (applicant.kind === APPLICANT_KIND.guarantor && applicant.relatedApplicant) {
    const { relatedApplicant } = applicant
    if (relatedApplicant.first_name) {
      return `${i18n.t('guarantor')} (${relatedApplicant.first_name
        ?.charAt(0)
        ?.toUpperCase()} ${relatedApplicant.last_name?.charAt(0)?.toUpperCase()})`
    }
    return i18n.t('guarantor')
  }
  return `${i18n.t('applicant')} ${key && key + 1}`
}
